import React, { FC } from "react";
import { IconProps } from "../types";

//Table of content SVG icon, use currentColor
export const TableOfContent: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      zoomAndPan="magnify"
      viewBox="0 0 768 767.999994"
      height="1024"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      fill="none"
    >
      <defs>
        <clipPath id="42a9c21ab6">
          <path
            d="M 137.109375 77 L 630.609375 77 L 630.609375 694 L 137.109375 694 Z M 137.109375 77 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <rect
        x="-76.8"
        width="921.6"
        y="-76.799999"
        height="921.599993"
        fillOpacity="1"
      />
      <rect
        x="-76.8"
        width="921.6"
        y="-76.799999"
        height="921.599993"
        fillOpacity="1"
      />
      <g clipPath="url(#42a9c21ab6)">
        <path
          fill="currentColor"
          d="M 478.570312 77.363281 L 219.914062 77.363281 C 174.203125 77.363281 137.007812 114.554688 137.007812 160.269531 L 137.007812 610.546875 C 137.007812 656.257812 174.203125 693.453125 219.914062 693.453125 L 548.089844 693.453125 C 593.796875 693.453125 630.988281 656.265625 630.988281 610.546875 L 630.988281 247.71875 Z M 490.652344 156.402344 L 560.28125 234.226562 L 490.652344 234.226562 Z M 548.082031 649.757812 L 219.914062 649.757812 C 198.292969 649.757812 180.707031 632.167969 180.707031 610.546875 L 180.707031 160.269531 C 180.707031 138.644531 198.292969 121.058594 219.914062 121.058594 L 446.953125 121.058594 L 446.953125 277.914062 L 587.292969 277.914062 L 587.292969 610.546875 C 587.285156 632.167969 569.699219 649.757812 548.082031 649.757812 Z M 548.082031 649.757812 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="currentColor"
        d="M 227.605469 519.054688 L 540.378906 519.054688 L 540.378906 562.75 L 227.605469 562.75 Z M 227.605469 519.054688 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="currentColor"
        d="M 227.605469 424.101562 L 540.378906 424.101562 L 540.378906 467.796875 L 227.605469 467.796875 Z M 227.605469 424.101562 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="currentColor"
        d="M 227.605469 329.164062 L 540.378906 329.164062 L 540.378906 372.859375 L 227.605469 372.859375 Z M 227.605469 329.164062 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  );
};
